import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {

    generate_tutor_pdf(aemter, tutors, translations, semester_readable) {
        var doc = new jsPDF({
          orientation: "landscape"
        });

        let tutorList = [];
        for (let amt of aemter) {
          for (let tutor of tutors[amt.id]) {
            if (tutor.assigned) {
              tutorList.push([
                amt.bezeichnung,
                tutor.bewohner.firstname + ' ' + tutor.bewohner.lastname,
                tutor.bewohner.zimmer.hausnummer.hausnummer + ' ' + tutor.bewohner.zimmer.zimmer,
                tutor.amt.amt_mail,
                tutor.bewohner.phone
              ]);
            }
          }
        }

        let title = translations.tutor_list_for + ' ' + semester_readable;
        var titleWidth = doc.getStringUnitWidth(title) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        var titleOffset = (doc.internal.pageSize.width - titleWidth) / 2;

        doc.text(title, titleOffset, 10);
        doc.autoTable({
          startY: 15,
          theme: "plain",
          head: [[translations.tutor_type, translations.tutor_name, translations.tutor_room, translations.tutor_mail, translations.tutor_phone]],
          body: tutorList
        });

        doc.save('Tutors.pdf');
    }
}
